<template>
  <div class="themed-pagination">
    <!-- Previous Button -->
    <themed-button
      variant="outline"
      size="default"
      @click="$emit('previous')"
      :disabled="currentPage === 1"
      class="themed-pagination__button"
    >
      Previous
    </themed-button>

    <!-- Page Info -->
    <div class="themed-pagination__info">
      Page {{ currentPage }} of {{ totalPages }}
    </div>

    <!-- Next Button -->
    <themed-button
      variant="outline"
      size="default"
      @click="$emit('next')"
      :disabled="currentPage === totalPages"
      class="themed-pagination__button"
    >
      Next
    </themed-button>
  </div>
</template>

<script>
import ThemedButton from './ThemedButton.vue';

export default {
  name: 'ThemedPagination',
  
  components: {
    ThemedButton
  },
  
  props: {
    currentPage: {
      type: Number,
      required: true,
      default: 1
    },
    totalPages: {
      type: Number,
      required: true,
      default: 1
    },
    totalItems: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    }
  }
};
</script>

<style lang="less">
@import '../../../../less/theme/v1/components/themed-pagination.less';
</style>
